import { IContractHistoryDTO, IRequestDTO } from "@/interface"
import { ContractHistory } from "@/models/subscription/contract-history"
import { Pagination } from "@/models/commons/pagination"

export class ContractHistoryPage {
    public pagination: Pagination;
    public data: (ContractHistory | null)[] | null;
    public path: string

    constructor(base: ContractHistoryPage) {
        if (base) {
            Object.assign(this, base);
        }
    }

    static fromDto(dto: IRequestDTO<IContractHistoryDTO>): ContractHistoryPage {
        return new ContractHistoryPage({
            pagination: Pagination.fromDto(dto),
            data: dto.data ? dto.data.map(data => ContractHistory.fromDto(data)) : null,
            path: dto.path
        });
    }
}
